// import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

import CreateCouponGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/CreateCoupon.gql';
import ApplyCouponGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/ApplyCoupon.gql';

import { parseInt } from 'lodash';

export default {
    create: variables => {
        variables = _.removeDeepByKey(variables, '__typename')
        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: CreateCouponGql,
                variables
            })
                .then(({data}) => {
                    // apolloClient.clearStore()
                    resolve(data.EX_POS_CreateCoupon)
                })
                .catch(err => reject(err))
        })
    },
    apply: (code, shop, pointOfSale, customer = null) =>
        new Promise((resolve, reject) => {
            let variables = {
                code,
                shop: parseInt(shop),
                pointOfSale: parseInt(pointOfSale),
                customer: customer ? parseInt(customer) : null,
            };

            apolloClient
                .mutate({
                    mutation: ApplyCouponGql,
                    variables,
                    // fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CO_ApplyCoupon))
                .catch(error => reject(error));
        })
};
